import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useInteractiveAttributes from '../../hooks/use-interactive-handler';
import { BORDER_RADIUSES } from './constants';

const InteractiveBox = ({
  borderRadius = BORDER_RADIUSES.medium,
  selected = false,
  focusable = false,
  borderless = false,
  children,
  onClick = Function.prototype,
}) => {
  const classes = classNames(
    'ws-ui-interactive-box',
    `ws-ui-interactive-box--border-radius-${borderRadius}`,
    {
      'ws-ui-interactive-box--focusable': focusable,
      'ws-ui-interactive-box--selected': selected,
      'ws-ui-interactive-box--borderless': borderless,
    }
  );

  const interactiveAttributes = useInteractiveAttributes(onClick);

  return (
    <div className={classes} onClick={onClick} {...(focusable && interactiveAttributes)}>
      {children}
    </div>
  );
};

InteractiveBox.propTypes = {
  borderRadius: PropTypes.oneOf(Object.values(BORDER_RADIUSES)),
  selected: PropTypes.bool,
  focusable: PropTypes.bool,
  borderless: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClick: PropTypes.func,
};

export default InteractiveBox;
